import * as moment from 'moment'
import { TimeRangeMoment } from 'src/app/model/time-range-moment';
export class TimeRange {
    start: Date;
    end: Date;
    label: string;
    get isRelative(): boolean {
        if (this.label != null) {
            return true;
        } else {
            return false;
        }
    }

    constructor(start?: Date | string, end?: Date | string, label?: string) {
        if (start) {
            this.start = new Date(start);
        }
        if (end) {
            this.end = new Date(end);
        }
        if (label) {
            this.label = label;
        }
        if (!start && !end && !label) {
            let tr: TimeRangeMoment = new TimeRangeMoment(moment().subtract(1, 'hour'), moment(), 'Last Hour');
            this.label = tr.label;
            this.start = tr.start.toDate();
            this.end = tr.end.toDate();
        }
    }
}